import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import {UserCountry} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {IUserApiProvider} from "data/providers/api/user.api.provider";
import {AVAIlABLE_ODDS_COUNTRIES} from "data/constants/odds";

export interface ICountryStore {
	get country(): UserCountry;
	get isShowOdds(): boolean;

	requestCountry(): Promise<void>;
}

@injectable()
export class CountryStore implements ICountryStore {
	@observable private _country = UserCountry.Other;

	get country() {
		return this._country;
	}

	get isShowOdds() {
		return AVAIlABLE_ODDS_COUNTRIES.includes(this.country);
	}

	constructor(@inject(Bindings.UserApiProvider) private _userApi: IUserApiProvider) {
		makeAutoObservable(this);
	}

	@action
	async requestCountry() {
		const response = await this._userApi.requestCountry();
		const {user} = response.data.success;

		runInAction(() => {
			this._country = user.cloudfrontCountry;
		});
	}
}
